import type { App } from 'vue'
import NProgress from 'nprogress'

// 创建自定义样式
function createCustomStyles() {
  // 检查是否已存在自定义样式
  const existingStyle = document.getElementById('nprogress-custom-styles')
  if (existingStyle)
    return

  const style = document.createElement('style')
  style.id = 'nprogress-custom-styles'
  style.innerHTML = `
    #nprogress {
      position: fixed !important;
      z-index: 999999 !important;
    }
    #nprogress .bar {
      background: var(--primary) !important;
    }
    #nprogress .peg {
      box-shadow: 0 0 10px var(--primary), 0 0 5px var(--primary) !important;
    }
  `
  document.head.appendChild(style)
}

export const nprogress = {
  install(app: App<Element>) {
    NProgress.configure({ showSpinner: false })

    // 添加自定义样式
    createCustomStyles()

    const router = app.config.globalProperties.$router
    router.beforeEach((to, from) => {
      // 登录首屏屏蔽
      if (to.path !== from.path && to.path !== '/')
        NProgress.start()
    })
    router.afterEach(() => {
      setTimeout(() => {
        NProgress.done()
      }, 100)
    })
  },
}
